//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/PositioningDimension.js";
import "../no/type.js";
import "../no/ugmath.js";
let d=[[],[[["subtype","target","target_associativity","target_help_point","tool","tool_associativity","tool_help_point"],"SetTargetAndTool",{},7,0],[["expression"],"SetExpression",{},1,0],[[],"CreatePositioningDimension",{},0,0],[[],"ShowPositioningDimensions",{},0,0],[[],"HidePositioningDimensions",{},0,0],[["reference","orientation"],"GetReferenceDirection",{},0,0],[["reference","orientation"],"SetReferenceDirection",{},2,0],[[],"UndoLastDimension",{},0,0],[[],"ApplyDimensions",{},0,0],[["num_dimensions"],"GetRpoDimensions",{R_:{dimensions:"Features.RPODimension[]"}},0,0],[["dimensions"],"SetRpoDimensions",{},1,0],[[],"CreateDimension",{R_:{dimensions:"Features.RPODimension"}},0,0]],[]];
SPLM.Features.RPOBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.RPOBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.RPOBuilder.AssociativityType = Object.freeze({
    "EndPoint" : "EndPoint", "ArcCenter" : "ArcCenter", "Tangency" : "Tangency", "EndPoint1" : "EndPoint1", "EndPoint2" : "EndPoint2", "VerticalCenterline1" : "VerticalCenterline1", "VerticalCenterline2" : "VerticalCenterline2", "HorizontalCenterline1" : "HorizontalCenterline1", "HorizontalCenterline2" : "HorizontalCenterline2"});

export default SPLM;